const getDeepActiveElement = (root: Document | ShadowRoot = document): Element | null => {
  const activeElement = root.activeElement

  if (activeElement?.shadowRoot) {
    return getDeepActiveElement(activeElement.shadowRoot)
  }

  return activeElement
}

export const blurActiveElement = () => {
  const activeElement = getDeepActiveElement()

  if (activeElement instanceof HTMLElement) {
    activeElement.blur()
  }
}
